/** Represents the electron utilities. */
class Electron {
  /** Checks whether the app is running as an electron application. */
  isElectron() {
    if (!window.electron) {
      return !!process?.versions?.electron || /electron/i.test(navigator.userAgent);
    }
    return !!window.electron;
  }
  /**
   * Gets the electron version.
   *
   * version 0.0.0 represents a unsupported version
   */
  async getVersion() {
    if (!window.electron) {
      return '0.0.0';
    }
    const desktopAppVersion = await window.electron.getVersion();
    return desktopAppVersion.split('-')[0];
  }
  /** Checks if the running Electron build is a standalone (non auto-updating windows version) */
  async isStandaloneBuild() {
    if (!window.electron?.isStandaloneBuild) {
      return null;
    }
    return await window.electron.isStandaloneBuild();
  }
  /** Checks if the running Electron build is installed from an windows MSI installer */
  async isMsiBuild() {
    if (!window.electron?.isMsiBuild) {
      return null;
    }
    return await window.electron.isMsiBuild();
  }
}
const electron = new Electron();

export { Electron, electron };
//# sourceMappingURL=index.es.js.map
